import { Container } from 'unstated';
import store from 'store';
import autobind from 'autobind-decorator';

const FILE_NAME = 'Orders';

export default class OrdersService extends Container {
  state = {
    ...this.getInitialData(),
    ...store.get(`${FILE_NAME}_state`),
    isSelectingProducts: false
  };

  getInitialData() {
    return {
      isSelectingProducts: false,
      items: []
    };
  }

  get selectedItemsCount() {
    return this.state.items.length;
  }

  async startSelecting() {
    await this.setState({
      ...this.state,
      isSelectingProducts: true
    });

    this.saveState();
  };

  async stopSelecting() {
    await this.setState({
      ...this.state,
      isSelectingProducts: false
    });

    this.saveState();
  };

  async selectProduct(product) {
    await this.setState({
      ...this.state,
      items: [...this.state.items, product]
    });

    this.saveState();
  }

  reset() {
    this.resetState();
  }

  saveState() {
    store.set(`${FILE_NAME}_state`, this.state);
  }

  resetState() {
    this.setState({
      ...this.getInitialData()
    });

    store.remove(`${FILE_NAME}_state`);
  }
}

export const ordersService = new OrdersService();
